import { Component, OnInit } from "@angular/core";
import { NavParams } from "@ionic/angular";
import { AccountBalanceService } from "src/app/services/balance/account-balance.service";
import { ConfigService } from "src/app/services/config/config.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { UtilsService } from "src/app/services/utils/utils.service";

@Component({
  selector: 'app-my-free-spin',
  templateUrl: './my-free-spin.component.html',
  styleUrls: ['./my-free-spin.component.scss'],
})

export class MyFreeSpinComponent implements OnInit {

  public accountBalances: any;
  public dailySlotEnabled: boolean = false;
  public error: any;
  public spins: number = 0;
  public spinNowBtnDisabled: boolean = true;
  public hideBonusFeature = false; // By default feature is enabled. 0 hides the feature.
  public hideBackButtonInNav = false;
  public dailySlotsEmpty: boolean = true;

  constructor(
    private readonly config: ConfigService,
    private readonly utilsService: UtilsService,
    private balanceService: AccountBalanceService,
    private gameHubControllerService: GameHubControllerService,
    private navParams: NavParams
  ) {
    this.hideBonusFeature = this.config.getConfig().FEATURE_GAME_BONUS_FREE_SPINS ? this.config.getConfig().FEATURE_GAME_BONUS_FREE_SPINS !== '0' : false;
    this.updateAndRefreshBalance();
    
  }

  ngOnInit(): void {
    if (this.navParams?.data?.hideBack) {
      this.hideBackButtonInNav = true;
    } else {
      this.hideBackButtonInNav = false;
    }
    const appConfig = this.config.getConfig();
    this.dailySlotEnabled = appConfig.SITE_HAS_DAILY_SLOT;
    this.dailySlotsEmpty = !this.dailySlotEnabled && (this.spins <= 0);
    
  }

  private updateAndRefreshBalance() {
    this.balanceService.updateBalance();
    this.balanceService.getBalance().subscribe((response: any) => {
      if (response) {
        this.accountBalances = response;
        this.spins = this.accountBalances?.MFREESPIN?.availableBalance ?? 0;
        this.spinNowBtnDisabled = this.spins <= 0;
      }
    }, (error) => this.error = error);
  }

  protected onClick() {
    return this.gameHubControllerService.launchDailySpin(this.spins);
  }

  protected getCDNAsset(stub: string): string {
    return this.utilsService.getCDNAsset(stub);
  }
}